var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
} 

// Popup Home page

$(document).ready(function () {
  // Open popup and play video
  $(".open").click(function () {
    $(".pop-outer").css("display", "flex").hide().fadeIn("slow", function () {
      $("body").addClass("abz-popup-open"); // add class to body
      var video = $("#popup-video").get(0);
      if (video) {
        video.currentTime = 0; // start from beginning
        video.play();
      }
    });
  });

  // Close popup and stop video
  $(".close").click(function () {
    $(".pop-outer").fadeOut("slow", function () {
      $("body").removeClass("abz-popup-open"); // remove class from body
      var video = $("#popup-video").get(0);
      if (video) {
        video.pause();
        video.currentTime = 0; // reset video
      }
    });
  });
});

// Home Page Video 

document.addEventListener("DOMContentLoaded", function () {
  const video = document.querySelector(".abz-new-video-text");
  const button = document.querySelector(".video-toggle");

  // Make sure video doesn't auto-play
  video.pause();

  // SVG play icon
  const playIcon = `
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_598_985)">
        <path d="M30 0C13.425 0 0 13.425 0 30C0 46.575 13.425 60 30 60C46.575 60 60 46.575 60 30C60 13.425 46.575 0 30 0ZM24 43.5V16.5L42 30L24 43.5Z" fill="black"/>
      </g>
      <defs>
        <clipPath id="clip0_598_985">
          <rect width="60" height="60" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  `;

  // Set play icon initially
  button.innerHTML = playIcon;

  // Play when clicking the button
  button.addEventListener("click", function () {
    video.play();
    button.classList.add("hidden"); // hide button while playing
  });

  // Pause when clicking the video itself
  video.addEventListener("click", function () {
    if (!video.paused) {
      video.pause();
    }
  });

  // Show button again when paused
  video.addEventListener("pause", function () {
    button.innerHTML = playIcon;  // show play icon
    button.classList.remove("hidden");
  });

  // Show button again when ended
  video.addEventListener("ended", function () {
    button.innerHTML = playIcon;
    button.classList.remove("hidden");
  });
});

// Home Page Video End

$(document).ready(function () {
  $('.abz-grid-slider').slick({
    slidesToShow: 3.5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow:'<svg class="slick-next  slick-arrow" xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" fill="none"><rect x="2" y="2" width="74" height="74" rx="8" fill="#B7D4E1" stroke="black" stroke-width="4"/><path d="M40.3174 31.6562C40.3174 29.5713 42.5346 28.3017 44.2402 29.4102L52.957 35.0752C55.6737 36.841 55.6828 40.9367 52.9736 42.7148L43.9883 48.6113C42.3969 49.6557 40.3176 48.4722 40.3174 46.5215V44.9541H29.7314C29.0041 44.9509 28.3081 44.6514 27.7959 44.1211C27.2836 43.5907 26.9971 42.8731 27 42.126V35.9941C26.9971 35.247 27.2836 34.5294 27.7959 33.999C28.3081 33.4688 29.0042 33.1692 29.7314 33.166H39.6348C39.8166 33.1652 39.9911 33.0896 40.1191 32.957C40.2469 32.8246 40.318 32.6454 40.3174 32.459V31.6562Z" fill="black"/><path d="M40.3174 31.6562C40.3174 29.5713 42.5346 28.3017 44.2402 29.4102L52.957 35.0752C55.6737 36.841 55.6828 40.9367 52.9736 42.7148L43.9883 48.6113C42.3969 49.6557 40.3176 48.4722 40.3174 46.5215V44.9541H29.7314C29.0041 44.9509 28.3081 44.6514 27.7959 44.1211C27.2836 43.5907 26.9971 42.8731 27 42.126V35.9941C26.9971 35.247 27.2836 34.5294 27.7959 33.999C28.3081 33.4688 29.0042 33.1692 29.7314 33.166H39.6348C39.8166 33.1652 39.9911 33.0896 40.1191 32.957C40.2469 32.8246 40.318 32.6454 40.3174 32.459V31.6562Z" stroke="#161616"/></svg>',
    prevArrow:'<svg class="slick-prev slick-arrow" xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" fill="none"><rect x="76" y="76" width="74" height="74" rx="8" transform="rotate(-180 76 76)" fill="#B7D4E1" stroke="black" stroke-width="4"/><path d="M37.6826 46.3437C37.6826 48.4287 35.4654 49.6983 33.7598 48.5898L25.043 42.9248C22.3263 41.159 22.3172 37.0633 25.0264 35.2852L34.0117 29.3887C35.6031 28.3443 37.6824 29.5278 37.6826 31.4785L37.6826 33.0459L48.2686 33.0459C48.9959 33.0491 49.6919 33.3486 50.2041 33.8789C50.7164 34.4093 51.0029 35.1269 51 35.874L51 42.0059C51.0029 42.753 50.7164 43.4706 50.2041 44.001C49.6919 44.5312 48.9958 44.8308 48.2686 44.834L38.3652 44.834C38.1834 44.8348 38.0089 44.9104 37.8809 45.043C37.7531 45.1754 37.682 45.3546 37.6826 45.541L37.6826 46.3437Z" fill="black"/><path d="M37.6826 46.3437C37.6826 48.4287 35.4654 49.6983 33.7598 48.5898L25.043 42.9248C22.3263 41.159 22.3172 37.0633 25.0264 35.2852L34.0117 29.3887C35.6031 28.3443 37.6824 29.5278 37.6826 31.4785L37.6826 33.0459L48.2686 33.0459C48.9959 33.0491 49.6919 33.3486 50.2041 33.8789C50.7164 34.4093 51.0029 35.1269 51 35.874L51 42.0059C51.0029 42.753 50.7164 43.4706 50.2041 44.001C49.6919 44.5312 48.9958 44.8308 48.2686 44.834L38.3652 44.834C38.1834 44.8348 38.0089 44.9104 37.8809 45.043C37.7531 45.1754 37.682 45.3546 37.6826 45.541L37.6826 46.3437Z" stroke="#161616"/></svg>',
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
    ]
  });
});

// Smooth auto scroll slider for each instance
document.addEventListener('DOMContentLoaded', function () {
  // Select all elements with a dynamic ID that matches 'smoothscroll-{section.id}'
  document.querySelectorAll('[id^="smoothscroll"]').forEach(function (slider) {
    new Splide(slider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      direction: slider.getAttribute('data-direction'),
      arrows: false,
      autoWidth: true,
      pagination: false,
      perPage: 4,
      autoScroll: {
        speed: 0,
      },
    }).mount(window.splide.Extensions);
  });
});


// Vertical thumbnails slider
customElements.define('abz-vertical-thumnails-content', class AbzVerticalThumbnailsContent extends HTMLElement {
  constructor() {
    super();
    this.slider = this;
    this.thumbnails = this.querySelectorAll('.thumbnail-list__item .thumbnail');
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
});

customElements.define('abz-vertical-thumnails', class AbzVerticalThumbnails extends HTMLElement {
  constructor() {
    super();
    this.slidesContainer = this.querySelector('.abz-vertical-thumnails-content');
    this.thumbnails = this.querySelectorAll('.thumbnail-list__item .thumbnail');
    this.prevButton = this.querySelector('.slider-button--prev');
    this.nextButton = this.querySelector('.slider-button--next');
    this.initVerticalThumbnails();
    this.setupEventListeners();
  }

  initVerticalThumbnails() {
    $(this.slidesContainer).slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      vertical: true,
      verticalSwiping: true,
      // swipeToSlide: true,
      infinite: false,
      arrows: true,
      prevArrow: this.prevButton,
      nextArrow: this.nextButton,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: false,
            vertical: false,
            verticalSwiping: false,
            // swipeToSlide: true,
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });

    // $(this.slidesContainer).on('afterChange', (event, slick, currentSlide) => {
    //   const currentSlideElement = slick.$slides.get(currentSlide);
    //   if (currentSlideElement) {
    //     const thumbnail = currentSlideElement.querySelector('.thumbnail');
    //     if (thumbnail) {
    //       thumbnail.click();
    //     }
    //   }
    // });
  }

  setupEventListeners() {
    this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        // $(this.slidesContainer).slick('slickGoTo', thumbnail.parentElement.dataset.index);
      });
    });
  }
});


// Footer accordion

$(document).ready(function(){
  // Apply accordion functionality only on mobile devices
  if ($(window).width() <= 768) {
    // Initially hide all accordion contents on mobile
    $('.abz-accordion-list .accordion-content').hide();

    // Ensure all icons are not rotated when the page is loaded
    $('.footer-coll-icon').removeClass('rotated');

    // Add click event listener for accordion heading (now targeting the h2 with the new classes)
    $('.abz-accordion-list .footer-block__heading').on('click', function() {
      var content = $(this).next('.accordion-content'); // Get the corresponding content
      var parentUl = $(this).closest('ul'); // Get the closest parent UL element
      var icon = $(this).find('.footer-coll-icon'); // Find the icon inside the heading

      // Slide up all open content
      $('.abz-accordion-list .accordion-content').not(content).slideUp(function() {
        // Remove rotation from all other icons when their content is closed
        $(this).prev('.footer-block__heading').find('.footer-coll-icon').removeClass('rotated');
      });

      // Toggle the clicked content
      content.stop(true, true).slideToggle(function() {
        // If the content is open, add the class to the parent UL and rotate the icon
        if (content.is(':visible')) {
          parentUl.addClass('accordion-open');
          icon.addClass('rotated'); // Rotate the icon when opened
        } else {
          parentUl.removeClass('accordion-open');
          icon.removeClass('rotated'); // Reset icon when closed
        }
      });
    });
  } else {
    // If it's not mobile, ensure content is always visible
    $('.abz-accordion-list .accordion-content').show();
    $('.abz-accordion-list').removeClass('accordion-open'); // Ensure class is removed on desktop
    $('.footer-coll-icon').removeClass('rotated'); // Reset all icons on desktop
  }
});




